// extracted by mini-css-extract-plugin
module.exports = {"userName":"TableAllUsersRow_userName__3d48F","userRole":"TableAllUsersRow_userRole__2hJgA","binField":"TableAllUsersRow_binField__TkqAr","bin":"TableAllUsersRow_bin__14nQF"};